<div class="container">
  <div class="title">{{ title }}</div>
  <div class="description">
    <ng-container *ngIf="showDescription">
      <ng-container *ngIf="description; else defaultDescription">{{ description }}</ng-container>
    </ng-container>
  </div>
  <ppl-info-box *ngIf="infoMessage"
                type="warning"
                [text]="infoMessage"></ppl-info-box>
  <ng-content></ng-content>
</div>

<ng-template #defaultDescription
             i18n="@@TwoFactorMethodSetupInitDescription">
  We will send you a verification code to authenticate for future logins.
</ng-template>